module.exports = __webpack_public_path__ + "img/brands-nmbs.750429df.svg";